import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as Fa from "react-icons/fa";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import {
    createAPIDocumentEndpoint,
    Endpoint,
} from "../../Services/DocumentAdjustment/DocumnetAdjusService";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import storage from "../../Services/Storage";
import Loader from "../../Components/Loader";
import { useLocation } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { MdRefresh } from "react-icons/md";

const Details = () => {
    // const [partyData,SetPartyData]= useState();
    const nav = useNavigate();
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState([]);
    const [partyname, setPartyname] = useState([]);
    const [balanceAllocation, setBalanceAllocation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [payableDocumentData, setPayableDocumentData] = useState([]);
    const [filteredPayableDocumentData, setFilteredPayableDocumentData] =
    useState([]);
    const [selectedPayableDocumentData, setSelectedPayableDocumentData] =
    useState([]);
    const [payablePopupShow, setPayablePopupShow] = useState(false);
    const [receivblePopupShow, setReceivblePopupShow] = useState(false);
    const [payableAllGridData, setPayableAllGridData] = useState([]);
    const [receivableDocumentData, setReceivableDocumentData] = useState([]);
    const [selectedreceivableDocumentData, setSelectedreceivableDocumentData] =
    useState([]);
    const [receiveableDocumentGridData, setReceiveableDocumentGridData] =
    useState([]);
    const [payableIsdata, setPayableIsdata] = useState(false);
    const [payableLoading, setPayableLoading] = useState(false);
    const [receiveLoading, setReceiveLoading] = useState(false);
    const [savebtnVisible, setSavebtnVisible] = useState(false);
    const [concurrentDisable, setConcurrentDisable] = useState(false);
    const [concurrentPopup, setConcurrentPopup] = useState(false);
    const [saveLoader, setSaveLoader] = useState(false);
    const [viewData, setViewData] = useState(false);
    const [viewDtDetailPay, setviewDtDetailPay] = useState([]);
    const [viewDtDetailRecv, setviewDtDetailRecv] = useState([]);
    const [custData, setCustData] = useState([]);
    const [custInfoPopUp, setCustInfoPopUp] = useState(false);
    const [custInfoPopUpMsg, setCustInfoPopUpMsg] = useState(false);
    const [concurrentCustId, setConcurrentCustId] = useState("");
    const navlink = useNavigate();
    const [searchparam] = useSearchParams();
    let AdjId = searchparam.get("MaskAdjId");
    const auth = storage.getLocal("user");
    const location = useLocation();
    const data = location?.state;
    // console.log("my data ", data);
    const [showPopup, setShowPop] = useState(false);
    const [otp, setOtp] = useState("");
    const [viewDocumentAdjustmentData, setViewDocumentAdjustmentData] =
    useState();
    const [docAdjCustData, setDocAdjCustData] = useState();
    const [docAdjRecv, setDocAdjRecvData] = useState();
    const [otpChecked, setOtpChecked] = useState("OTPReq");
    const [disableRadio, setDisableRadio] = useState("");
    const [viewCust, setViewCust] = useState([]);
    const [otpBtnVisible, setOtpBtnVisible] = useState(true);
    const [otpValidateBtn, setOtpValidateBtn] = useState(false);

    useEffect(() => {
        populatePartyData();
        if (AdjId != null) {
            // populateViewData(AdjId);
            setViewData(true);
        }
        if (data != null) {
            // console.log(data,"dataaaaa");
            setOnchangepartyname(data?.PARTY);
            getViewDocumentAdjustmentData(data);
            setViewCust(data);
        }
        setOtpValidateBtn(false);
    }, []);
    const onOTPReqChange = (val) => {
        if (val === "OTPReq") {
            const FilterData = [];
            for (let i = 0; i < payableDocumentData.length; i++) {
                if (
                    payableDocumentData[i].REAS_DESC !== "Cash Discount" &&
          payableDocumentData[i].REAS_DESC !== "Credit Note" &&
          payableDocumentData[i].SCHM_CODE !== "COMPSCHEME"
                ) {
                    FilterData.push(payableDocumentData[i]);
                }
            }
            // console.log(FilterData, "PayableOTP");
            setFilteredPayableDocumentData(FilterData);
        } else if (val === "OTPNotReq") {
            const FilterData = [];
            for (let i = 0; i < payableDocumentData.length; i++) {
                if (
                    payableDocumentData[i].REAS_DESC === "Cash Discount" ||
          payableDocumentData[i].REAS_DESC === "Credit Note" ||
          payableDocumentData[i].SCHM_CODE === "COMPSCHEME"
                ) {
                    FilterData.push(payableDocumentData[i]);
                }
            }
            // console.log(FilterData, "PayableOTP");
            setFilteredPayableDocumentData(FilterData);
        }
    };
    const onCustChange = async (e) => {
    // debugger;
        setOnchangepartyname(e);
        // console.log(e, "Cust");
        if(e?.MASK_PARTY_ID){        
            try {
                const res = await createAPIDocumentEndpoint().get(
                    `${Endpoint.GetCustDetl}?PartyId=${encodeURIComponent(e.MASK_PARTY_ID)}&CompId=${auth.CompId}`
                );
                // console.log(res.data.Data, "Cust");
                if (res.data.Data.length > 0) {
                    setCustData(res.data.Data);
                    if (
                        res.data.Data[0].SUPP_TAG == "N" &&
          res.data.Data[0].CUST_TAG == "Y"
                    ) {
                        if (
                            res.data.Data[0].KYC_STATUS == "" ||
            res.data.Data[0].KYC_STATUS != "A"
                        ) {
                            setCustInfoPopUp(true);
                            setCustInfoPopUpMsg(
                                "Please submit KYC details by visiting Customer Master screen"
                            );
                        }
                        if (res.data.Data[0].MOBILE == "") {
                            setCustInfoPopUp(true);
                            setCustInfoPopUpMsg(
                                "Please submit Mobile No. by visiting Customer Master screen"
                            );
                        } else if (res.data.Data[0].SUPP_TAG == "Y") {
                            toast.warn(
                                "Present document adjustment process is available for Customers only",
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    pauseOnFocusLoss: false,
                                    closeButton: false,
                                    autoClose: 3000,
                                }
                            );
                        }
                    }
                } else {
                    toast.warn("Customer details not found", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    };
    const populatePartyData = () => {
        createAPIDocumentEndpoint()
            .get(`${Endpoint.GetPartyName}?CompId=${auth.CompId}`)
            .then((response) => {
                // console.log("responseData", response.data);
                setPartynamesugg(response.data.Data);
            })
            .catch(() => {});
    // setPartynamesugg(party);
    };

    // const populateViewData = (AdjId) => {
    //     setSaveLoader(true);
    //     createAPIDocumentEndpoint()
    //         .get(
    //             `${Endpoint.ViewDocumentAdjustment}?MASK_ADJ_ID=${AdjId}&CompId=${auth.CompId}`
    //         )
    //         .then((response) => {
    //             console.log("viewresponseData", response);
    //             setviewDtDetailPay(response.data.DtDetailPay);
    //             setviewDtDetailRecv(response.data.DtDetailRecv);
    //             setOnchangepartyname(response.data.DtHeader[0].PARTY);
    //             setSaveLoader(false);
    //         })
    //         .catch(() => {
    //             setSaveLoader(false);
    //         });
    // };

    const searchEmployee = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...partynamesugg];
            } else {
                _filteredemployee = partynamesugg.filter((employee) => {
                    return (
                        employee.PARTY_CODE.toLowerCase().includes(e.query.toLowerCase()) ||
            employee.PARTY_NAME.toLowerCase().includes(e.query.toLowerCase())
                    );
                });
            }

            setPartyname(_filteredemployee);
        }, 250);
    };

    const employeeTemplate = (employee) => {
        return (
            <>
                {employee.PARTY_CODE} - {employee.PARTY_NAME}
            </>
        );
    };

    const receivableDocumentAmt = () => {
        if (Object.keys(onchangepartyname).length === 0) {
            toast.warn("Please select Customer Name", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else if (!payableIsdata) {
            toast.warn("Please select payable document(s)", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else {
            receivableAmountGrid(onchangepartyname.MASK_PARTY_ID);
        }
    // console.log("setOnchangepartyname", onchangepartyname);
    };

    const payableDocumntAmt = () => {
    // debugger;
        if (Object.keys(onchangepartyname).length === 0) {
            toast.warn("Please select Customer Name", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else {
            setPayableDocumentData([]);
            paybleAmountGridData(
                onchangepartyname.MASK_PARTY_ID,
                custData[0]?.CHANNEL_ID,
                custData[0]?.EXPIRY
            );
        }
    };

    const paybleAmountGridData = (partyId, channel, expiry) => {
        setPayableLoading(true);
        setOtpChecked("OTPReq");
        createAPIDocumentEndpoint()
            .get(
                `${Endpoint.GetPayableDocument}?PartyId=${encodeURIComponent(partyId)}&CompId=${auth.CompId}&Channel=${channel}&IsCustExpired=${expiry}`
            )
            .then((response) => {
                // console.log("responseData", response.data);
                if (response.data.Status === "Warning") {
                    setPayableDocumentData([]);
                    setPayableLoading(false);
                    // setPayablePopupShow(true);
                } else {
                    setPayableDocumentData(response.data.Data);
                    // console.log(response.data.Data, "PayableOTP");
                    const FilterData = [];
                    for (let i = 0; i < response.data.Data.length; i++) {
                        if (
                            response.data.Data[i].REAS_DESC !== "Cash Discount" &&
              response.data.Data[i].REAS_DESC !== "Credit Note" &&
              response.data.Data[i].SCHM_CODE !== "COMPSCHEME"
                        ) {
                            FilterData.push(response.data.Data[i]);
                        }
                    }
                    // console.log(FilterData, "PayableOTP");
                    setFilteredPayableDocumentData(FilterData);
                    setPayableLoading(false);
                    // setPayablePopupShow(true);
                }
                // setPayableDocumentData(response.data.Data);
            })
            .catch((ex) => {
                console.log(ex);
                setPayableLoading(false);
            });
        setPayablePopupShow(true);
    // setPayableDocumentData(dataArray);
    };

    const receivableAmountGrid = (partyId) => {
        setReceiveLoading(true);
        createAPIDocumentEndpoint()
            .get(`${Endpoint.GetReceivableDocument}?PartyId=${encodeURIComponent(partyId)}`)
            .then((response) => {
                // console.log("responseData", response.data);
                if (response.data.Status === "Warning") {
                    setReceivableDocumentData([]);
                    setReceiveLoading(false);
                } else {
                    setReceivableDocumentData(response.data.Data);
                    setReceiveLoading(false);
                }
            })
            .catch(() => {
                setReceiveLoading(false);
            });
        // setReceivableDocumentData(dataArray1);
        setReceivblePopupShow(true);
    };
    const handleOkPayable = () => {
        let balanceamt = selectedPayableDocumentData.reduce((prev, curr) => {
            return Number(prev) + Number(curr.PAYABLE_AMOUNT);
        }, 0);
        balanceamt = Number(balanceamt).toFixed(2);
        setBalanceAllocation(balanceamt);
        setTotalAmount(balanceamt);
        setPayableAllGridData(selectedPayableDocumentData);
        setPayablePopupShow(false);
        if (selectedPayableDocumentData.length > 0) {
            setPayableIsdata(true);
        } else {
            setPayableIsdata(false);
        }
    };

    const handleOkReceivable = () => {
        let updatedselectedreceivableDocumentData = [];
        updatedselectedreceivableDocumentData = selectedreceivableDocumentData.map(
            (obj) => ({
                ...obj,
                amount: 0,
            })
        );
        let remainingAmount = totalAmount;
        updatedselectedreceivableDocumentData.forEach((item) => {
            if (remainingAmount >= item.PAYABLE_AMOUNT) {
                item.amount = Number(item.PAYABLE_AMOUNT).toFixed(2);
                remainingAmount -= Number(item.PAYABLE_AMOUNT).toFixed(2);
            } else {
                item.amount = Number(remainingAmount).toFixed(2);
                remainingAmount = 0;
            }
        });

        let reminingBalanceAllocation =
      updatedselectedreceivableDocumentData.reduce((prev, curr) => {
          return Number(prev) + parseFloat(curr.amount);
      }, 0);
        // console.log("totalAmount",totalAmount);
        // console.log("totalAmount",reminingBalanceAllocation);
        reminingBalanceAllocation = Number(reminingBalanceAllocation).toFixed(2);
        setBalanceAllocation(totalAmount - reminingBalanceAllocation);

        if (
            payableAllGridData.length > 0 &&
      updatedselectedreceivableDocumentData.length > 0
        ) {
            setSavebtnVisible(true);
        } else {
            setSavebtnVisible(false);
        }

        setReceiveableDocumentGridData(updatedselectedreceivableDocumentData);
        setReceivblePopupShow(false);
    };
    const handleClickPayableCancel = () => {
        setPayablePopupShow(false);
    };
    const handleClickReceiveCancel = () => {
        setReceivblePopupShow(false);
    };

    const onAmountChange = (val, rowData) => {
        const updatedData = receiveableDocumentGridData.map((item) => {
            if (item.DOCUMENT_NO === rowData.DOCUMENT_NO) {
                return { ...item, amount: val };
            }
            return item;
        });
        setReceiveableDocumentGridData(updatedData);
    };

    const handleInputChange = (e, index) => {
        const value = e.target.value;
        const newOtp = otp.substring(0, index) + value + otp.substring(index + 1);
        setOtp(newOtp);
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (!otp[index] && index > 0) {
                document.getElementById(`otp-${index - 1}`).focus();
            }
        }
    };

    useEffect(() => {
        let reminingBalanceAllocation = receiveableDocumentGridData.reduce(
            (prev, curr) => {
                return parseFloat(prev) + parseFloat(curr.amount);
            },
            0
        );
        reminingBalanceAllocation = Number(reminingBalanceAllocation).toFixed(2);
        // console.log(reminingBalanceAllocation,"totalAmount");
        // console.log(totalAmount,"totalAmount");
        setBalanceAllocation(totalAmount - reminingBalanceAllocation);
    }, receiveableDocumentGridData);

    const renderAction = (rowData) => {
        return (
            <>
                {Number(rowData.amount) == 0 && (
                    <div className="action-icon">
                        <div
                            className="d-inline"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Cancel"
                        >
                            <button
                                className="grid-icon"
                                onClick={() => {
                                    cancelrecv(rowData.DOCUMENT_NO);
                                }}
                            >
                                <Fa.FaTimes className="cancel" />
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    };

    const cancelrecv = (documentnumber) => {
        let removedreceved = receiveableDocumentGridData.filter((item) => {
            return item.DOCUMENT_NO !== documentnumber;
        });

        setReceiveableDocumentGridData(removedreceved);
    };

    const getOtp = async () => {
    // console.log("datad datad ",data, " viewDocumentAdjustmentData viewDocumentAdjustmentData ",docAdjCustData);
        try {
            const res = await createAPIDocumentEndpoint().get(
                `${Endpoint.GenerateOTP}?PARTY_ID=${encodeURIComponent(viewCust.MASK_PARTY_ID)}&Mobile=${docAdjCustData[0].MOBILE}&AdjAmt=${viewDocumentAdjustmentData[0].ADJ_AMT}&InvoiceNo=${encodeURIComponent(docAdjRecv[0]?.RCV_DOC_NO)}&CN_No=${viewDocumentAdjustmentData[0].PAY_DOC_NO}&CompId=${auth?.CompId}&UserId=${auth?.UserId}`
            );
            console.log("Response of getOtp:", res);
            setShowPop(true);
            toast.warn(res.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
        } catch (error) {
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
            console.error("Error occurred:", error);
        }
    };

    const validateOtp = async () => {
        setOtpValidateBtn(true);
        try {
            const res = await createAPIDocumentEndpoint().get(
                `${Endpoint.ValidateOTP}?CompId=${auth.CompId}&PARTY_ID=${encodeURIComponent(viewCust.MASK_PARTY_ID)}&Mobile=${docAdjCustData[0].MOBILE}&OTP=${otp}&AdjAmt=${viewDocumentAdjustmentData[0].ADJ_AMT}&InvoiceNo=${docAdjRecv[0]?.RCV_DOC_NO}&CN_No=${viewDocumentAdjustmentData[0].PAY_DOC_NO}&MASK_ADJ_ID=${data.MASK_ADJ_ID}`
            );
            if (res.data.Status == "Success") {
                toast.success("OTP verified successfully", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setOtpBtnVisible(false);
            }
            setOtp("");
            setShowPop(false);
        } catch (error) {
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
            console.error("Error occurred:", error);
        }
    };

    const getViewDocumentAdjustmentData = async (parameter) => {
        try {
            const res = await createAPIDocumentEndpoint().get(
                `${Endpoint.ViewDocumentAdjustmentData}?PartyId=${encodeURIComponent(parameter?.MASK_PARTY_ID)}&MASK_ADJ_ID=${AdjId}&CompId=${auth.CompId}&Status=${parameter?.STATUS}`
            );
            // const res = await createAPIDocumentEndpoint().get(`${Endpoint.ViewDocumentAdjustmentData}?PartyId=${'91413549|000|CS00824'}&MASK_ADJ_ID=${'000|20210702000004'}&CompId=${'13305037'}&Status=${parameter?.STATUS}`);
            if (res.data.Status == "Success") {
                // console.log("view ", res.data);
                setViewDocumentAdjustmentData(res.data.DtDetailPay);
                setDocAdjCustData(res.data.DtCustDtl);
                setDocAdjRecvData(res.data.DtDetailRecv);
                setviewDtDetailPay(res.data.DtDetailPay);
                setviewDtDetailRecv(res.data.DtDetailRecv);
                setOnchangepartyname(res.data.DtHeader[0].PARTY);
            }
            if (res.data.Status != "Success") {
                toast.error("Failed to get customer data", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
            }
        } catch (error) {
            console.log("Error ", error);
        }
    };

    const saveDocumentdata = () => {
    // console.log("receiveableDocumentGridData", receiveableDocumentGridData);
    // console.log("payableAllGridData", payableAllGridData);
    // console.log("balanceAllocation", balanceAllocation);
    // console.log("totalAmount", totalAmount);

        let paydetails = payableAllGridData.map((val) => ({
            masK_DOCUMENT_ID: val.MASK_ACPR_ID,
            paY_DOC_NO: val.DOCUMENT_NO,
            paY_DOC_DATE: val.DOCUMENT_DATE,
            acpR_TOTAL_VAL: val.MASK_DOCUMENT_AMT.toString(),
            adJ_AMT: val.PAYABLE_AMOUNT.toString(),
            masK_DOCUMENT_TYPE: val.MASK_DOC_TYPE,
            masK_DOCUMENT_SR_NO: val.PAYTERM_SERIAL_NUMBAR,
            reaS_CODE: val.REAS_CODE,
            reaS_DESC: val.REAS_DESC,
        }));
        let receivedetails = receiveableDocumentGridData.map((val) => ({
            rcV_DOC_NO: val.DOCUMENT_NO,
            rcV_DOC_DATE: val.DOCUMENT_DATE,
            acpR_TOTAL_VAL: val.MASK_DOCUMENT_AMT.toString(),
            calC_AMT: val.amount.toString(), //
            adJ_AMT: val.PAYABLE_AMOUNT.toString(),
            masK_DOCUMENT_TYPE: val.MASK_DOC_TYPE,
            masK_DOCUMENT_SR_NO: val.PAYTERM_SERIAL_NUMBAR,
        }));

        let receive = receiveableDocumentGridData.reduce((prev, curr) => {
            return Number(prev) + Number(curr.amount);
        }, 0);
        receive = Number(receive).toFixed(2);
        let payble = payableAllGridData.reduce((prev, curr) => {
            return Number(prev) + Number(curr.PAYABLE_AMOUNT);
        }, 0);
        payble = Number(payble).toFixed(2);

        console.log("receive", receive);
        console.log("payble", payble);
        // console.log();

        const checkAmountVsPayable = (invoice) => {
            let amount = parseFloat(invoice.amount);
            let payableAmount = parseFloat(invoice.PAYABLE_AMOUNT);
            if (amount > payableAmount) {
                return true;
            }
            return false;
        };
        let isAmountGreaterThanPayable = false;
        let itCantBeZero = false;
        if (receiveableDocumentGridData.length > 0) {
            receiveableDocumentGridData.forEach((invoice) => {
                if (checkAmountVsPayable(invoice)) {
                    isAmountGreaterThanPayable = true;
                }
                return null;
            });
            receiveableDocumentGridData.forEach((item) => {
                if (Number(item.amount) == 0) {
                    itCantBeZero = true;
                }
                return null;
            });
        }

        if (isAmountGreaterThanPayable) {
            toast.warn(
                "Adjusted Amount is greater than payable amount for Outstanding Receivables",
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                }
            );
        } else if (itCantBeZero) {
            toast.warn("Adjusted Amount can't be 0 or empty", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 4000,
            });
        } else if (Number(balanceAllocation).toFixed(2) < 0) {
            toast.warn("Balance for Allocation can't be negative", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else {
            let payload = {
                compId: auth.CompId,
                userId: auth.UserId,
                partyId: onchangepartyname.MASK_PARTY_ID,
                hdnChannel: custData[0]?.CHANNEL_ID,
                hdnIsCashDisc: otpChecked === "OTPReq" ? "False" : "True",
                listPayDetail: paydetails,
                listRevcDetail: receivedetails,
            };

            // console.log("payload", payload);
            // return;
            setSaveLoader(true);
            createAPIDocumentEndpoint()
                .post(`${Endpoint.SaveDocumentAdjustment}`, JSON.stringify(payload), {
                    headers: { "Content-Type": "application/json" },
                })
                .then((res) => {
                    // console.log("Ab000", res.data);

                    if (res.data.Status === "Success") {
                        toast.success("Document Adjusted successfully", {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setSaveLoader(false);
                        createAPIDocumentEndpoint()
                            .getConcurrent(
                                `${Endpoint.ReleaseLock}?CustId=${encodeURIComponent(concurrentCustId)}&UserId=${auth?.UserId}`
                            )
                            .then((response) => {
                                // console.log("responseData", response.data);
                                if (response.data.Status === "Success") {
                                    // window.location.reload();
                                }
                            })
                            .catch((e) => {
                                console.log("Error", e);
                            });
                        navlink("/creditmanagement/documentadjustment");
                    } else {
                        // console.log(res.data);
                        setSaveLoader(false);
                    }
                })
                .catch((error) => {
                    toast.error(error.response.data.Message, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setSaveLoader(false);
                });
        }
    };

    const handleConcurrent = (e) => {
        setConcurrentCustId(e.value.MASK_PARTY_ID);
        if (AdjId == null) {
            createAPIDocumentEndpoint()
                .getConcurrent(
                    `${Endpoint.AcquireLock}?CustId=${encodeURIComponent(e?.value?.MASK_PARTY_ID)}&UserId=${auth?.UserId}`
                )
                .then((response) => {
                    // console.log("responseData", response.data);
                    if (response.data.Status === "Success") {
                        setConcurrentDisable(true);
                    } else if (response.data.Status === "Warning") {
                        setConcurrentPopup(true);
                    }
                })
                .catch((e) => {
                    console.log("Error", e);
                });
        }
    };

    const concurrentPopupOk = () => {
        setOnchangepartyname([]);
        setConcurrentPopup(false);
    };

    const handleReset = () => {
        createAPIDocumentEndpoint()
            .getConcurrent(
                `${Endpoint.ReleaseLock}?CustId=${encodeURIComponent(concurrentCustId)}&UserId=${auth?.UserId}`
            )
            .then((response) => {
                // console.log("responseData", response.data);
                if (response.data.Status === "Success") {
                    // setConcurrentDisable(true);
                    // console.log(response.data);
                    window.location.reload();
                } else if (response.data.Status === "Warning") {
                    // setConcurrentPopup(true);
                }
            })
            .catch((e) => {
                console.log("Error", e);
            });
    };
    const isRowSelectable = (event) => {
        if(event.data.DATE_FREEZE == null){
            return true;
        }
        const [day, month, year] = event.data.DATE_FREEZE.split("/");
        const inputDate = new Date(`${year}-${month}-${day}`);
        const today = new Date();
        console.log(inputDate,today,"isRowSelectable");

        if(inputDate < today){
            return false;
        }
        else{
            return true;
        }
    };
    const isFreeze = (date) => {
        if(date == null){
            return false;
        }
        const [day, month, year] = date.split("/");
        const inputDate = new Date(`${year}-${month}-${day}`);
        const today = new Date();
        console.log(inputDate,today,"isRowSelectable");

        if(inputDate < today){
            return true;
        }
        else{
            return false;
        }
    };
    const getRowClass = (rowData) => {
        // if (!check_date || rowData.DATE_FREEZE == null) return "skyBlue";
        // else if (rowData.DAYS_DIFF >= 0 && rowData.DAYS_DIFF < 90) return "orange";
        // else if (rowData.QRM_APPROVED_CUST_ID != "" || rowData.QRM_APPROVED_SCHEME != "") return "white";
        // else return "lightGreen";
        // const check_date = compareDate(rowData.DATE_FREEZE);
        return{
            "bg-info": rowData.DATE_FREEZE !== null && isFreeze(rowData?.DATE_FREEZE)
        };
    };
    if (saveLoader) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mx-1">
                                    <li className="breadcrumb-item">
                                        <Link to="/creditmanagement/documentadjustment">
                      Document Adjustment
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                    Details
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end">
                                {data?.STATUS === "Approved" && otpBtnVisible && (
                                    <button
                                        type="submit"
                                        className="btn btn-outline-primary me-3"
                                        onClick={getOtp}
                                    >
                    Generate OTP
                                    </button>
                                )}
                                <Link to="/creditmanagement/documentadjustment">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-primary me-3"
                                    >
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                    Records
                                    </button>
                                </Link>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={!concurrentDisable}
                                    onClick={() => {
                                        handleReset();
                                    }}
                                >
                  Reset <MdRefresh style={{ fontSize: 18 }} />
                                </button>
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        <form>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                    Customer Name <span className="mandatory">*</span>
                                    </label>
                                    <div className="d-block">
                                        <AutoComplete
                                            field="PARTY_NAME"
                                            value={onchangepartyname}
                                            suggestions={partyname}
                                            completeMethod={searchEmployee}
                                            onChange={(e) => {
                                                // setOnchangepartyname(e.target.value);
                                                onCustChange(e.target.value);
                                            }}
                                            onSelect={(e) => handleConcurrent(e)}
                                            dropdown={true}
                                            itemTemplate={employeeTemplate}
                                            emptyMessage="No Customer Name found."
                                            showEmptyMessage
                                            disabled={concurrentDisable}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <label className="form-label">Balance for Allocation</label>
                                    <InputText
                                        value={Number(balanceAllocation).toFixed(2)}
                                        className="form-control"
                                        disabled
                                    />
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <label className="form-label">Total Amount</label>
                                    <InputText
                                        value={totalAmount}
                                        className="form-control"
                                        disabled
                                    />
                                </div>

                                {!viewData && (
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="float-end mt-4">
                                            {savebtnVisible && (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-3"
                                                    onClick={saveDocumentdata}
                                                >
                          Save
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary me-3"
                                                onClick={receivableDocumentAmt}
                                            >
                        Receivable Document
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={payableDocumntAmt}
                                            >
                        Payable Document
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </form>
                    </section>

                    {/* <section className="">
            <div className="DataTable pb-4 pt-1">
              {payableLoading ? (
                <Loader />
              ) : (
                <DataTable
                  value={payableAllGridData}
                  paginator
                  rows={10}
                  showGridlines
                  stripedRows
                  filterDisplay="row"
                  emptyMessage="No Records found to display."
                  tableStyle={{ minWidth: "60rem" }}
                >
                  <Column
                    field="DOCUMENT_NO"
                    header="Document Number"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="DOCUMENT_DATE"
                    header="Document Date"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="MASK_DOCUMENT_AMT"
                    header="Document Amount"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="PAYABLE_AMOUNT"
                    header="Outstanding Payables"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                </DataTable>
              )}
            </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <h3>Receivable Records</h3>
            <div className="DataTable pb-4 pt-1">
              {receiveLoading ? (
                <Loader />
              ) : (
                <DataTable
                  value={receiveableDocumentGridData}
                  paginator
                  rows={10}
                //   showGridlines
                  stripedRows
                  filterDisplay="row"
                  emptyMessage="No Records found to display"
                  tableStyle={{ minWidth: "60rem" }}
                >
                  <Column
                    field="DOCUMENT_NO"
                    header="Document Number"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="DOCUMENT_DATE"
                    header="Document Date"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="MASK_DOCUMENT_AMT"
                    header="Document Amount"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                  <Column
                    field="amount"
                    header="Adjusted Amount"
                    body={(rowData) => (
                      <InputText
                        value={rowData.amount}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const regex = /^\d*\.?\d{0,2}$/;
                          if (regex.test(inputValue) || inputValue === "") {
                            onAmountChange(inputValue, rowData);
                          }
                        }}
                      />
                    )}
                  />
                  <Column
                    field="PAYABLE_AMOUNT"
                    header="Outstanding Receivables"
                    filterMatchMode="contains"
                    filter
                    filterPlaceholder="Search Here..."
                  ></Column>
                </DataTable>
              )}
            </div>
          </section> */}
                    {viewData ? (
                        <section className="">
                            <h3>Payable Records</h3>
                            <div className="DataTable pb-4 pt-1">
                                <DataTable
                                    value={viewDtDetailPay}
                                    paginator
                                    rows={10}
                                    // showGridlines
                                    stripedRows
                                    emptyMessage="No Records found to display."
                                    tableStyle={{ minWidth: "60rem" }}
                                >
                                    <Column field="PAY_DOC_NO" header="Document Number"></Column>
                                    <Column field="PAY_DOC_DATE" header="Document Date"></Column>
                                    <Column
                                        field="ACPR_TOTAL_VAL"
                                        header="Document Amount"
                                    ></Column>
                                    <Column
                                        field="ADJ_AMT"
                                        header="Outstanding Payables"
                                    ></Column>
                                </DataTable>
                            </div>
                            <h3>Receivable Records</h3>
                            <div className="DataTable pb-4 pt-1">
                                <DataTable
                                    value={viewDtDetailRecv}
                                    paginator
                                    rows={10}
                                    // showGridlines
                                    stripedRows
                                    emptyMessage="No Records found to display"
                                    tableStyle={{ minWidth: "60rem" }}
                                >
                                    <Column field="RCV_DOC_NO" header="Document Number"></Column>
                                    <Column field="RCV_DOC_DATE" header="Document Date"></Column>
                                    <Column
                                        field="ACPR_TOTAL_VAL"
                                        header="Document Amount"
                                    ></Column>
                                    {/* <Column
                                    field="CALC_AMT"
                                    header="Adjusted Amount"
                   
                                /> */}
                                    <Column
                                        field="ADJ_AMT"
                                        header="Outstanding Receivables"
                                    ></Column>
                                </DataTable>
                            </div>
                        </section>
                    ) : (
                        <section className="">
                            <h3>Payable Records</h3>
                            <div className="DataTable pb-4 pt-1">
                                {payableLoading ? (
                                    <Loader />
                                ) : (
                                    <DataTable
                                        value={payableAllGridData}
                                        paginator
                                        rows={10}
                                        // showGridlines
                                        stripedRows
                                        filterDisplay="row"
                                        emptyMessage="No Records found to display."
                                        //   rowsPerPageOptions={[10, 25, 50]}
                                        tableStyle={{ minWidth: "60rem" }}
                                    >
                                        <Column
                                            field="DOCUMENT_NO"
                                            header="Document Number"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_DATE"
                                            header="Document Date"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="MASK_DOCUMENT_AMT"
                                            header="Document Amount"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="PAYABLE_AMOUNT"
                                            header="Outstanding Payables"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        {/* <Column field={renderAction} header="Action" /> */}
                                    </DataTable>
                                )}
                            </div>
                            <h3>Receivable Records</h3>
                            <div className="DataTable pb-4 pt-1">
                                {receiveLoading ? (
                                    <Loader />
                                ) : (
                                    <DataTable
                                        value={receiveableDocumentGridData}
                                        paginator
                                        rows={10}
                                        // showGridlines
                                        stripedRows
                                        filterDisplay="row"
                                        emptyMessage="No Records found to display"
                                        //   rowsPerPageOptions={[10, 25, 50]}
                                        tableStyle={{ minWidth: "60rem" }}
                                    >
                                        <Column
                                            field="DOCUMENT_NO"
                                            header="Document Number"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_DATE"
                                            header="Document Date"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="MASK_DOCUMENT_AMT"
                                            header="Document Amount"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="amount"
                                            header="Adjusted Amount"
                                            body={(rowData) => (
                                                <InputText
                                                    value={rowData.amount}
                                                    // onChange={(e) => onAmountChange(e, rowData)}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        const regex = /^\d*\.?\d{0,2}$/;
                                                        if (regex.test(inputValue) || inputValue === "") {
                                                            onAmountChange(inputValue, rowData);
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        <Column
                                            field="PAYABLE_AMOUNT"
                                            header="Outstanding Receivables"
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column body={renderAction} header="Action "></Column>
                                    </DataTable>
                                )}
                            </div>
                        </section>
                    )}

                    <div className="">
                        <Dialog
                            header="Payable Records"
                            visible={payablePopupShow}
                            style={{ width: "80vw" }}
                            onHide={() => setPayablePopupShow(false)}
                            closable={false}
                            resizable={false}
                            draggable={false}
                        >
                            <div className="col-lg-12 col-md-12 col-sm-12 my-3 d-flex justify-content-center">
                                <div className="d-inline-flex">
                                    <div className="flex align-items-center">
                                        <RadioButton
                                            inputId="ingredient1"
                                            name="OTP"
                                            value="OTPReq"
                                            onChange={(e) => {
                                                setOtpChecked(e.value);
                                                onOTPReqChange(e.value);
                                            }}
                                            checked={otpChecked === "OTPReq"}
                                            disabled={disableRadio === "OTPReq"}
                                        />
                                        <label htmlFor="ingredient1" className="me-4 ms-2">
                      OTP Approval Required
                                        </label>
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton
                                            inputId="ingredient2"
                                            name="OTP"
                                            value="OTPNotReq"
                                            onChange={(e) => {
                                                setOtpChecked(e.value);
                                                onOTPReqChange(e.value);
                                            }}
                                            checked={otpChecked === "OTPNotReq"}
                                            disabled={disableRadio === "OTPNotReq"}
                                        />
                                        <label htmlFor="ingredient2" className="ms-2">
                      No OTP Required
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-12 col-sm-12">
                                <div className="DataTable mb-3">
                                    <DataTable
                                        value={filteredPayableDocumentData}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        selectionMode="checkbox"
                                        selection={selectedPayableDocumentData}
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        showSelectAll={false}
                                        onSelectionChange={(e) => {
                                            setSelectedPayableDocumentData(e.value);
                                            if (e?.value[0]?.REAS_DESC !== undefined) {
                                                if (
                                                    (e?.value[0]?.REAS_DESC !== "Cash Discount" ||
                            e?.value[0]?.REAS_DESC !== "Credit Note") &&
                          e?.value[0]?.SCHM_CODE !== "COMPSCHEME"
                                                ) {
                                                    setDisableRadio("OTPNotReq");
                                                } else if (
                                                    e?.value[0]?.REAS_DESC === "Cash Discount" ||
                          e.value[0]?.REAS_DESC === "Credit Note" ||
                          e.value[0]?.SCHM_CODE === "COMPSCHEME"
                                                ) {
                                                    setDisableRadio("OTPReq");
                                                }
                                            } else {
                                                setDisableRadio("");
                                            }
                                        }}
                                        emptyMessage="No Records found to display"
                                        isDataSelectable={(event) => isRowSelectable(event)} 
                                        rowClassName={getRowClass}
                                    >
                                        <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "5rem" }}
                                            header="Select All"
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_NO"
                                            header="Document Number"
                                            style={{ minWidth: "8rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_DATE"
                                            header="Document Date"
                                            style={{ minWidth: "12rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="REAS_DESC"
                                            header="Reason"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            style={{ minWidth: "12rem" }}
                                        ></Column>
                                        <Column
                                            field="PAYABLE_AMOUNT"
                                            header="Outstanding Payables"
                                            style={{ minWidth: "12rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                    </DataTable>
                                </div>
                            </div>
                            <div className="float-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    onClick={handleOkPayable}
                                >
                  OK
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-cancel-red"
                                    onClick={handleClickPayableCancel}
                                >
                  Cancel
                                </button>
                            </div>
                        </Dialog>
                    </div>
                    <div className="">
                        <Dialog
                            header="Receivable Records"
                            visible={receivblePopupShow}
                            style={{ width: "80vw" }}
                            onHide={() => setReceivblePopupShow(false)}
                            closable={false}
                            resizable={false}
                            draggable={false}
                        >
                            <div className="col-md-12 col-lg-12 col-sm-12">
                                <div className="DataTable mb-3">
                                    <DataTable
                                        value={receivableDocumentData}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        selectionMode="checkbox"
                                        selection={selectedreceivableDocumentData}
                                        // rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        showSelectAll={false}
                                        onSelectionChange={(e) => {
                                            setSelectedreceivableDocumentData(e.value);
                                        }}
                                        emptyMessage="No Records found to display"
                                        tableStyle={{ minWidth: "20rem" }}
                                    >
                                        <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3rem" }}
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_NO"
                                            header="Document Number"
                                            style={{ minWidth: "8rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_DATE"
                                            header="Document Date"
                                            style={{ minWidth: "12rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        {/* <Column
                  field="REAS_DESC"
                  header="Reason"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                  style={{ minWidth: "12rem" }}
                ></Column> */}
                                        <Column
                                            field="PAYABLE_AMOUNT"
                                            header="Outstanding Payables"
                                            style={{ minWidth: "12rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                    </DataTable>
                                </div>
                            </div>
                            <div className="float-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    onClick={handleOkReceivable}
                                >
                  OK
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-cancel-red"
                                    onClick={handleClickReceiveCancel}
                                >
                  Cancel
                                </button>
                            </div>
                        </Dialog>
                    </div>
                </div>
                {showPopup && (
                    <Dialog
                        header="Information"
                        visible={true}
                        style={{ width: "40vw" }}
                        closable={false}
                        resizable={false}
                        draggable={false}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                            {Array.from({ length: 6 }).map((_, index) => (
                                <InputText
                                    key={index}
                                    id={`otp-${index}`}
                                    value={otp[index] || ""}
                                    onChange={(e) => handleInputChange(e, index)}
                                    maxLength={1}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    style={{ width: "40px", margin: "5px", textAlign: "center" }}
                                />
                            ))}
                            {/* <InputText keyfilter="int" placeholder="000000" value={otp} onChange={(e) => handleChangeOTP(e)} /> */}
                            {/* <InputOtp value={otp} onChange={(e)=>handleChangeOTP(e)} integerOnly length={6} /> */}
                        </div>
                        <div className="float-end mt-3">
                            <button
                                type="button"
                                className="btn btn-outline-primary me-3"
                                onClick={validateOtp}
                                disabled= {otpValidateBtn}
                            >
                Verify OTP
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={getOtp}
                            >
                Resend OTP
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={() => {
                                    setShowPop(false);
                                    setOtp("");
                                }}
                            >
                Close
                            </button>
                        </div>
                    </Dialog>
                )}
                <Dialog
                    header="Confirmation"
                    visible={custInfoPopUp}
                    style={{ width: "50vw" }}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                        <p>{custInfoPopUpMsg}</p>
                    </div>
                    <div className="float-end mt-4">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={() => {
                                setCustInfoPopUp(false);
                                nav(
                                    `/masters/customermaster/details?maskCustId=${
                                        encodeURIComponent(onchangepartyname.MASK_PARTY_ID)
                                    }&partyCode=${
                                        encodeURIComponent(onchangepartyname.PARTY_CODE)
                                    }&custType=normal&id=${"2"}`
                                );
                            }}
                        >
              Go To Customer Master
                        </button>
                        {/* <button
                            type="button"
                            className="btn btn-cancel me-3"
                            onClick={() => {
                                setCustInfoPopUp(false);
                            }}
                        >
                  cancel
                        </button> */}
                    </div>
                </Dialog>
                <Dialog
                    header="Confirmation"
                    visible={concurrentPopup}
                    style={{ width: "50vw" }}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                        <p>
              Some other user is using this customer for document adjustment.
                        </p>
                    </div>
                    <div className="float-end mt-4">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={() => concurrentPopupOk()}
                        >
              OK
                        </button>
                    </div>
                </Dialog>
            </>
        );
    }
};

export default Details;
